import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const expiryAPI = createApi({
    reducerPath: "expiryAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllExpiredItems: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/expiry-entry?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["expiries"],
        }),
        deleteExpiredItem: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/expiry-entry/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["expiries"],
        }),

        markAsExpiredItem: builder.mutation({
            query: ({ productId, data }) => {
                return {
                    url: `admin/product/${productId}/expiry-entry`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["expiries"],
        })
    })
});

export const { 
    useGetAllExpiredItemsMutation,
    useDeleteExpiredItemMutation,
    useMarkAsExpiredItemMutation
} = expiryAPI;

export default expiryAPI;